import type { CommandHandler } from '../types';

export const implementWithAiCommandHandler: CommandHandler = (_command, context) => {
  const taskId = Number(context.entityId);
  if (!Number.isInteger(taskId) || taskId <= 0) {
    return { success: false, error: 'Open a saved task first.' };
  }
  if (context.hasUnsavedChanges) {
    return { success: false, error: 'Save task changes before starting AI implementation.' };
  }
  if (!context.openImplementWithAiDialog) {
    return { success: false, error: 'AI implementation dialog is not available.' };
  }

  context.openImplementWithAiDialog(taskId);
  return { success: true };
};
